import React from 'react';
import PropTypes from 'prop-types'
import fastSecure from '../../images/login/fastSecure.svg';
import utilityBills from '../../images/login/utilityBills.svg';
import payEveryWhere from '../../images/login/payEveryWhere.svg';
import dealsOffers from '../../images/login/dealsOffers.svg';
import CrossIcon from '../../images/login/latestCrossIcon.svg';

import Modal from './modal';
import { disableBodyScrolling } from '../../utils';

function LoginModal({
  closeLoginModal
}) {
    return (
      <Modal overlay>
        <div className="loginModalContainer">
          <div className="iframeHolder"></div>
          <div className="loginPopupText">
            <div className="loginDesc">
              <div className="benefitsTitle">Benefits Of Paytm Account</div>
              <div className="descItem">
                <img src={fastSecure} alt="dummyIcon" />
                <span className="desc">Fast &amp; Secure Payments</span>
              </div>
              <div className="descItem">
                <img src={utilityBills} alt="dummyIcon" />
                <span className="desc">Pay Utility Bills or Mobile Recharge &amp; Get Cashbacks</span>
              </div>
              <div className="descItem">
                <img src={payEveryWhere} alt="dummyIcon" />
                <span className="desc">Pay at over 10 million Paytm merchant network</span>
              </div>
              <div className="descItem">
                <img src={dealsOffers} alt="dummyIcon" />
                <span className="desc">Amazing deals on Travel, Movies &amp; Shopping</span>
              </div>
            </div>
            <span className="closeIframe" onClick={closeLoginModal}><img src={CrossIcon} alt="Close" /></span>
            </div>
        </div>
        
      </Modal>
    );
}

LoginModal.propTypes = {
  closeLoginModal: PropTypes.func.isRequired,
};

export default LoginModal;
